import React, { useState } from "react";
import { Stack } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";

import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

import styles from "./index.module.scss";
import Body1 from "../typography/body-01";
import LoaderModal from "../modal/loader-modal";

const SupportingDocs = ({
	fileCount,
	fileTypes,
	text,
	handleFileAttach,
	multiple,
	flat = false,
	loadingText = "Reading file...",
	onUnsupportedFileType,
}) => {
	const [error, setError] = useState("");
	const [isReadingFiles, setIsReadingFiles] = useState(false);

	const handleFileSelection = async (file) => {
		setError("");
		setIsReadingFiles(true);

		try {
			// Yield to the browser so the loading modal can paint before file processing starts.
			await new Promise((resolve) => {
				if (typeof window !== "undefined" && window.requestAnimationFrame) {
					window.requestAnimationFrame(() => resolve());
					return;
				}

				setTimeout(resolve, 0);
			});

			await Promise.resolve(handleFileAttach(file));
		} catch (err) {
			console.error("[SupportingDocs] file processing failed", err);
		} finally {
			setIsReadingFiles(false);
		}
	};

	return (
		<>
			<LoaderModal open={isReadingFiles} text={loadingText} />

			<FileUploader
				key={Math.floor(Math.random() * 100)}
				handleChange={handleFileSelection}
				name="file"
				types={fileTypes}
				multiple={multiple}
				onTypeError={(err) => {
					if (onUnsupportedFileType) {
						onUnsupportedFileType(err);
						return;
					}

					setError(err);
				}}
			>
				{error && <Body1 text={error} extraClass={styles.errorText} />}

				<form
					method="post"
					className={flat ? styles.formFlatContainer : styles.formContainer}
				>
					<FileUploadOutlinedIcon className={styles.uploadIcon} />

					<Stack flexDirection="row" className={styles.uploadTextContainer}>
						<Body1 text="Click Here" extraClass={styles.clickText} />
						<Body1 text={text} extraClass={styles.uploadText} />
					</Stack>

					{fileCount !== undefined && fileCount > 0 && (
						<Body1
							text={`${fileCount} ${fileCount === 1 ? "file" : "files"} selected`}
							extraClass={styles.filesText}
						/>
					)}
				</form>
			</FileUploader>
		</>
	);
};

export default SupportingDocs;
